import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

import { App } from "@/App";

/*
 * Fonts, self-hosted, loaded here rather than by the component tree so the
 * prerender bundle stays free of CSS.
 *
 * These replace `next/font`, and the swap is like for like: the files are
 * served from our own origin, split by unicode-range so a browser fetches
 * only the subsets it needs, and named in keglam.css by role rather than by
 * family. Only the weights the design system actually sets are imported —
 * see the grouped `font-weight: 800` rule for the display face.
 */
import "@fontsource-variable/bricolage-grotesque/wght.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/700.css";

import "lenis/dist/lenis.css";
import "@/styles/keglam.css";

const root = document.getElementById("root");
if (root === null) throw new Error("#root is missing from index.html");

hydrateRoot(
  root,
  <StrictMode>
    <App path={window.location.pathname} />
  </StrictMode>,
);
